import type { FormKitNode } from '@formkit/core'
import { rootClasses as baseRootClasses } from './formkit.theme'

const globalOverrides: Record<string, string> = {
  'selection:text-neutral-700': 'selection:text-muted-color',
  'text-neutral-700': 'text-muted-color-emphasis',
  'max-w-[20em]': ''
}

const additions: Partial<Record<string, Partial<Record<string, boolean>>>> = {
  text__label: {
    'font-outline': true
  },
  form__message: {
    'text-center': true
  }
}

export function rootClasses(sectionName: string, node: FormKitNode): Record<string, boolean> {
  const key = `${node.props.type}__${sectionName}`
  const base = baseRootClasses(sectionName, node)

  const overridden: Record<string, boolean> = {}
  for (const [className, _] of Object.entries(base)) {
    overridden[globalOverrides[className] ?? className] = true
  }

  Object.assign(overridden, additions[key])
  return overridden
}
